// This is the common text that will show up in both the registration and sign up screens
import {MANDATORY_ICON} from "../../framework/component/form/FormComponents";
import React from "react";

export const COMMON_HEADER = <p>
      We request that researchers only register to UK Biobank if they wish to apply for data access to undertake research.
      Information about UK Biobank and application procedures can be found on our website
      (<a
        href={"https://www.ukbiobank.ac.uk/enable-your-research/register"}>https://www.ukbiobank.ac.uk/enable-your-research/register</a>)
      or by raising a ticket
      (<a
        href={"https://community.ukbiobank.ac.uk/hc/en-gb/requests/new"}>https://community.ukbiobank.ac.uk/hc/en-gb/requests/new</a>).
      <br/><br/>
      If you have any problems with Registration or you have any questions please see our Online Help or raising a ticket
      with UK Biobank using the link above.
    </p>
;

export const MANDATORY_FIELD = <p>Items marked with <MANDATORY_ICON/> are required to submit a
  registration</p>;

/*
* TODO These constants should ideally be sys prefs. We are hardcoding it here for now as it's how it's already done in the
*  old world. In the future need to implement a sys pref framework in the New World (Ticket #23698)
*/
export const FIRST_NAME_MAX_LENGTH = 120;
export const LAST_NAME_MAX_LENGTH = 120;
export const EMAIL_MAX_LENGTH = 80;
export const USERNAME_MAX_LENGTH = 64;
export const MIN_PASSWORD_LENGTH = 12;
export const USERNAME_REGEX = /^(?!.*\.@)(?!.*\.$)(?!.*\.{2,})[A-Za-z0-9'._!#^~\-]{1,64}$/;
export const PASSWORD_REGEX =
    /^(?:(?=.*[a-z])(?=.*[A-Z])(?=.*\d)|(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9])|(?=.*[a-z])(?=.*\d)(?=.*[^a-zA-Z0-9])|(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]))[ -~]+$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export const MINIMUM_AGE = 16;